// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-layout .v-toolbar__content,.box-layout header.header.header-flat{padding:0 10px}.box-layout .mt--100.mt-sm-10{margin-top:50px}", ""]);
// Exports
module.exports = exports;
